module.exports = __webpack_public_path__ + "img/1.04.thmb.1266a4fa.jpg";